import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WifiOff } from "lucide-react";

/**
 * Small persistent banner shown at the top of the screen while the browser
 * reports we're offline. Per PWA spec §10: we never fake success, we tell
 * the customer clearly that ordering requires a connection.
 */
const OfflineBanner = () => {
    const [offline, setOffline] = useState(
        typeof navigator !== "undefined" && !navigator.onLine
    );

    useEffect(() => {
        const goOffline = () => setOffline(true);
        const goOnline = () => setOffline(false);
        window.addEventListener("offline", goOffline);
        window.addEventListener("online", goOnline);
        return () => {
            window.removeEventListener("offline", goOffline);
            window.removeEventListener("online", goOnline);
        };
    }, []);

    return (
        <AnimatePresence>
            {offline && (
                <motion.div
                    data-testid="offline-banner"
                    initial={{ y: -60, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -60, opacity: 0 }}
                    transition={{ type: "spring", damping: 22, stiffness: 300 }}
                    className="fixed top-0 inset-x-0 z-50 mx-auto max-w-md
                               bg-[#2C1A12] text-white px-4 py-2.5
                               flex items-center gap-2 justify-center text-sm"
                    role="status"
                >
                    <WifiOff className="h-4 w-4" strokeWidth={2.5} />
                    <span className="font-display font-bold">
                        You're offline. Reconnect to keep ordering.
                    </span>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default OfflineBanner;
